export var Themes;
(function (Themes) {
    Themes["VODAFONE_WS2"] = "VODAFONE_WS2";
    Themes["VODAFONE_WS10"] = "VODAFONE_WS10";
    Themes["ZIGGO_WS2"] = "ZIGGO_WS2";
})(Themes || (Themes = {}));
//# sourceMappingURL=theme.models.js.map